import Header from "components/header";
import React from "react";

import { useNavigate, useParams } from "react-router-dom";
import { Accordion, Container, Grid, Image } from "semantic-ui-react";

import {
  GetHeroImage,
  GetPlayerProfile,
  PlayerProfile,
} from "./profileLoader";

import { formatWinRate, getMainHero } from "./utils";

import HeroTable from "./heroTable";
import PartnerTable from "./partnerTable";
import OpponentTable from "./opponentTable";
import StageTable from "./stageTable";
import { ProfilePictureLoader } from "./profilePictures/profilePictureLoader";

const PlayerProfileView = () => {
  const navigate = useNavigate();
  const { playerName } = useParams<{ playerName: string }>();

  if (!playerName) {
    return <div>Invalid Player Name</div>;
  }

  const playerProfile: PlayerProfile | undefined = GetPlayerProfile(playerName);

  if (!playerProfile) {
    return <div>Player not found</div>;
  }

  const eloTwoDecimal = Number(playerProfile.elo).toFixed(2);

  const mainHero = getMainHero(playerProfile.hero_stats_dict);

  const proflePicture = ProfilePictureLoader(playerProfile.name);

  return (
    <div className="melee-wrapper">
      <Container
        className="regular-text"
        style={{ paddingTop: 10, paddingBottom: 10 }}
      >
        <Header
          helmet={playerProfile.name}
          rightMenu={
            <button
              className="melee-inline-button"
              onClick={() => navigate('/players/')}
            >
              Back
            </button>
          }
        />
        <Grid>
          <Grid.Row stackable>
            <Grid.Column style={{ width: "auto" }}>
              {proflePicture && (
                <div
                  className="picked-hero-container tier-border-1"
                  style={{ maxWidth: 80, marginLeft: "auto", marginTop: "3em" }}
                >
                  <Image
                    src={proflePicture}
                    alt="Unpicked Icon"
                    size="tiny"
                    style={{ width: 76, height: 76 }}
                  />
                  </div>
                )}

              {mainHero &&
                (
                  <div
                    className="picked-hero-container tier-border-1"
                    style={{
                      maxWidth: 80,
                      marginLeft: "auto",
                      marginTop: "3em",
                    }}
                  >
                    <Image
                      src={GetHeroImage(mainHero[0])}
                      alt={mainHero[0]}
                      size="tiny"
                    />
                  </div>
                )}
            </Grid.Column>
            <Grid.Column style={{ width: "auto", textAlign: "left" }}>
              <div style={{ marginTop: '2.5em', marginBottom: '4.5em' }}>
                <h1 style={{ marginBottom: 0 }}>{playerProfile.name}</h1>
                <h4 style={{ marginTop: 0 }}>Rating: {eloTwoDecimal}</h4>
              </div>

              <table className="melee-stats-table">
                <tr>
                  <td>Games played:</td>
                  <td className="right-column">{playerProfile.win_count + playerProfile.lose_count}</td>
                </tr>
                <tr>
                  <td>Wins:</td>
                  <td className="right-column">{playerProfile.win_count}</td>
                </tr>
                <tr>
                  <td>Losses:</td>
                  <td className="right-column">{playerProfile.lose_count}</td>
                </tr>
                <tr>
                  <td>Win Rate:</td>
                  <td className="right-column">{formatWinRate(playerProfile.win_count, playerProfile.lose_count)}</td>
                </tr>
              </table>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Accordion>

        </Accordion>
        <HeroTable heroes={playerProfile.hero_stats_dict} />
        <PartnerTable
          currentPlayerName={playerProfile.name}
          games={playerProfile.games}
        />
        <OpponentTable currentPlayerName={playerProfile.name} games={playerProfile.games} />
        <StageTable currentPlayerName={playerProfile.name} games={playerProfile.games} />
      </Container>
    </div>
  );
};

export default PlayerProfileView;
